import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  modal: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',

    padding: '4rem 4rem 2rem 4rem',

    backgroundColor: theme.palette.container.background,
    boxShadow: `0 2px 4px ${theme.palette.container.shadow}`,
  },
  overlay: {
    zIndex: 10,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,

    backgroundColor: theme.palette.modal.overlay,
  },
}));

export default useStyles;
